import { cast, flow, getParent, types } from 'mobx-state-tree';
import { persist } from 'mst-persist';
import { INotificationCenter } from '.';

export const NotificationCenterEventTypes = ['Updates', 'Events', 'Sales', 'Announcements', 'Community', 'Maintenance'];

export const NotificationCenterEventsSession = types
    .model('Notification center events session', {
        subscribedEvents: types.optional(types.array(types.string), NotificationCenterEventTypes),
    })
    .actions((self) => {
        const actions = {
            afterCreate() {
                actions.fetch();
            },
            fetch: flow(function* () {
                yield persist('notification-events-session', self, {
                    storage: localStorage,
                });
                if (window.win.name === 'settings') {
                    const filtered = self.subscribedEvents.filter((i) => NotificationCenterEventTypes.includes(i));
                    if (self.subscribedEvents.length !== filtered.length) {
                        self.subscribedEvents = cast(filtered);
                        window.nxlApi.frontEnd.pub('notificationEventsUpdate');
                    }
                }
            }),
            subscribe(event: string) {
                if (!self.subscribedEvents.includes(event)) self.subscribedEvents.push(event);
            },
            unsubscribe(event: string) {
                if (self.subscribedEvents.includes(event)) self.subscribedEvents.remove(event);
            },
            subscribeAll() {
                self.subscribedEvents = cast(NotificationCenterEventTypes);
            },
        };
        return actions;
    });

export const NotificationCenterSession = types
    .model('Notification center session', {
        readIDs: types.array(types.number),
        removedIDs: types.array(types.number),
    })
    .views((self) => ({
        get parent(): INotificationCenter {
            return getParent<INotificationCenter>(self);
        },
    }))
    .actions((self) => {
        const actions = {
            afterAttach: flow(function* () {
                if (window.win.name !== 'settings') {
                    yield persist(`notification-center-session-${window.application.userNo}`, self, {
                        storage: localStorage,
                    });
                }
            }),
            read(id: number) {
                if (!self.readIDs.includes(id)) self.readIDs.push(id);
            },
            remove(id: number) {
                if (!self.removedIDs.includes(id)) self.removedIDs.push(id);
            },

            /// clean up old notification IDs
            /// it needs to be called after all contents are fetched include custom ones
            cleanup() {
                const existedNotificationIds = self.parent.data.map((v) => v.notificationId);
                if (existedNotificationIds.length < self.readIDs.length) {
                    const read = self.readIDs.filter((v) => existedNotificationIds.includes(v));
                    self.readIDs = cast(read);
                }
                if (existedNotificationIds.length < self.removedIDs.length) {
                    const removed = self.removedIDs.filter((v) => existedNotificationIds.includes(v));
                    self.removedIDs = cast(removed);
                }
                ///
            },
        };
        return actions;
    });
